export const API_KEY = '10d965d35c41a0696c54bc9b5a5dbfc9'